module.exports = __webpack_public_path__ + "static/img/m2_t3_edge.6c0622c9.jpg";